import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Nova Função ", -1)
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Nome Menu", -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Icon", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Rota", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Save", -1)
const _hoisted_16 = { class: "pt-3 pb-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.linkname) = $event)),
          class: "form-control",
          name: "linkname"
        }, null, 512), [
          [_vModelText, $setup.data.linkname]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.icon) = $event)),
          class: "form-control",
          name: "icon"
        }, null, 512), [
          [_vModelText, $setup.data.icon]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.route) = $event)),
          class: "form-control",
          placeholder: "Ex: /nome_da_rota",
          name: "route",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.route]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.note) = $event)),
          class: "form-control",
          name: "note"
        }, null, 512), [
          [_vModelText, $setup.data.note]
        ])
      ]),
      _hoisted_15
    ], 32),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ])
  ]))
}